import { render, staticRenderFns } from "./GeneralAgentFormContact.vue?vue&type=template&id=94859646&scoped=true&"
import script from "./GeneralAgentFormContact.vue?vue&type=script&lang=ts&"
export * from "./GeneralAgentFormContact.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralAgentFormContact.vue?vue&type=style&index=0&id=94859646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94859646",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
